// extracted by mini-css-extract-plugin
export default {"table":"orderItemsList_table__eFTMM"};